// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","Primary":"Button_Primary__38CGK","Danger":"Button_Danger__2ogZq"};